import {
  GET_PRODUCTS,
  GET_PRODUCT_CATEGORIES,
  SELECT_PRODUCT,
  SAVE_PRODUCT,
  GET_PRODUCT_ATTRIBUTES,
  GET_PRODUCT_OPTIONS,
  SAVE_PRODUCT_OPTION,
  UPDATE_PRODUCT_ATTRIBUTE,
} from './actions';

const initialState = {
  products: [],
  product_categories: [],
  selected_product: {},
  product_attributes: [],
  product_options: [],
};

export default function Reducer(state = initialState, action) {
  const { type, data } = action;
  switch (type) {
    case GET_PRODUCTS:
      return {
        ...state,
        products: data,
      };
    case GET_PRODUCT_CATEGORIES:
      return {
        ...state,
        product_categories: data,
      };
    case SELECT_PRODUCT:
      return {
        ...state,
        selected_product: data,
      };
    case SAVE_PRODUCT:
      return {
        ...state,
        products: state.products.map((product) =>
          product.id === data.id ? data : product
        ),
        selected_product: data,
      };
    case GET_PRODUCT_ATTRIBUTES:
      return {
        ...state,
        product_attributes: data,
      };
    case GET_PRODUCT_OPTIONS:
      return {
        ...state,
        product_options: data,
      };
    case SAVE_PRODUCT_OPTION:
      return {
        ...state,
        product_options: [...state.product_options, data],
      };
    case UPDATE_PRODUCT_ATTRIBUTE:
      return {
        ...state,
      };
    default:
      return state;
  }
}
